export const SERVICES = [
  {
    id: "emobilite",
    num: "01",
    name: "E-MOBILITÉ",
    title: "Trottinettes & vélos électriques",
    tagline: "La fusée reste fusée.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#00F3FF",
    glow: "rgba(0,243,255,0.30)",
    image:
      "https://images.unsplash.com/photo-1603114595212-71ee69bb6eb1?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Réparation de la roue moteur d'une trottinette électrique",
    description:
      "Réparation, entretien et montage de trottinettes électriques et de vélos électriques, en tout genre — à domicile ou à l'atelier. Depuis la construction de ma trottinette fusée, j'entretiens tout ce qui roule sur batterie.",
    tasks: [
      "Diagnostic & réparation électrique",
      "Entretien complet & réglages",
      "Montage & customisation",
      "Commande de la bonne pièce détachée",
    ],
  },
  {
    id: "informatique",
    num: "02",
    name: "INFORMATIQUE",
    title: "Réparation, maintenance & montage PC",
    tagline: "Un PC qui rame, ça se soigne.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#A855F7",
    glow: "rgba(168,85,247,0.30)",
    image:
      "https://images.unsplash.com/photo-1604754742629-3e5728249d73?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Montage d'une carte graphique dans un ordinateur",
    description:
      "PC qui rame, écran bleu, panne mystérieuse ou envie d'une machine montée main : diagnostic honnête, réparation propre et montage solide. Sur ton poste, portable ou sur-mesure.",
    tasks: [
      "Diagnostic & dépannage matériel",
      "Remplacement de pièces (SSD, RAM, CM)",
      "Montage PC gamer sur-mesure",
      "Nettoyage, pâte thermique, optimisation",
      "Installations & mises à jour",
    ],
  },
  {
    id: "smartphone",
    num: "03",
    name: "SMARTPHONE",
    title: "Réparation téléphone mobile",
    tagline: "Écran cassé, batterie morte : ça revit.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#FF3B30",
    glow: "rgba(255,59,48,0.30)",
    image:
      "https://images.unsplash.com/photo-1746005514011-ea00280f3b6e?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Composants d'un téléphone démonté sur tapis de réparation",
    description:
      "Remplacement d'écran, remplacement de batterie, flash et modification de firmware, nettoyage en profondeur : ton téléphone reprend une seconde vie sans y laisser ton budget. Diagnostic rapide, remontage soigné, test complet avant restitution.",
    tasks: [
      "Remplacement d'écran / vitre",
      "Remplacement de batterie",
      "Flash & modification de firmware",
      "Nettoyage en profondeur",
      "Diagnostic de panne rapide",
      "Remontage soigné & test complet",
    ],
  },
  {
    id: "batiment",
    num: "04",
    name: "PETITS TRAVAUX",
    title: "Bâtiment d'intérieur",
    tagline: "Fils d'artisan peintre, c'est la maison.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#FF6B00",
    glow: "rgba(255,107,0,0.30)",
    image:
      "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Rouleau appliquant de la peinture bleue sur un mur",
    description:
      "Grandi avec un père artisan peintre et passé par presque 6 ans de chantiers tous corps d'état : je connais le bâtiment par cœur. Petits travaux d'intérieur, propres et bien finis.",
    tasks: [
      "Peinture & finitions",
      "Ponçage, rebouchage, préparation",
      "Pose d'accessoires & de mobilier",
      "Petites réparations d'intérieur",
      "Rénovation légère",
    ],
  },
  {
    id: "personnalisation",
    num: "05",
    name: "PERSONNALISATION",
    title: "Éclairage & peinture personnalisés",
    tagline: "La lumière qui claque, la couleur qui marque.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#EAB308",
    glow: "rgba(234,179,8,0.30)",
    image:
      "https://images.pexels.com/photos/34195903/pexels-photo-34195903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    imageAlt: "Rubans de LED multicolores illuminant une pièce sombre",
    description:
      "Donne du style à ton intérieur, ta déco ou tes objets : pose de LED et d'éclairage d'ambiance, rubans lumineux et rétroéclairage, finitions peinture et custom, pose carbone déco. Du propre, du net, à ton goût — à domicile ou à l'atelier.",
    tasks: [
      "LED & éclairage d'ambiance",
      "Rubans lumineux & rétroéclairage",
      "Peinture & finitions custom",
      "Pose carbone & stickers déco",
      "Relooking de petits objets & mobilier",
    ],
  },
  {
    id: "accompagnement",
    num: "06",
    name: "ACCOMPAGNEMENT",
    title: "Compagnie, présence & figurant",
    tagline: "Parler, ou pas. Être là, c'est déjà ça.",
    requestType: "accompagnement",
    ctaLabel: "Demander un accompagnement",
    color: "#10B981",
    glow: "rgba(16,185,129,0.30)",
    image:
      "https://images.unsplash.com/photo-1773420656161-5c1013265c8c?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Deux personnes se promenant dans un parc au coucher du soleil",
    description:
      "Besoin d'aller quelque part avec quelqu'un ? Une place en trop dans vos billets et personne à inviter ? Besoin de parler… ou non, juste d'être accompagné ? Je suis là. Je peux aussi faire figurant.",
    tasks: [
      "Accompagnement déplacements & rendez-vous",
      "Compagnie & présence bienveillante",
      "Figuration (événements, photos, films)",
      "Coup de main ponctuel",
      "Parler ou juste être là, au choix",
    ],
  },
  {
    id: "covoiturage",
    num: "07",
    name: "COVOITURAGE",
    title: "Conducteur & covoiturage",
    tagline: "Une route à faire ? On la fait ensemble.",
    requestType: "covoiturage",
    ctaLabel: "Demander un trajet",
    color: "#3B82F6",
    glow: "rgba(59,130,246,0.30)",
    image:
      "https://images.unsplash.com/photo-1738748140408-61b8965748b8?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Voiture roulant sur une route au coucher du soleil",
    description:
      "Besoin d'un déplacement ? Une route à effectuer de temps en temps ? Je propose mes services de covoiturage : tu annonces ton trajet, je conduis, tu partages les frais. Sérieux et détendu, bagages compris.",
    tasks: [
      "Déplacements ponctuels & réguliers",
      "Longues routes, prévues à l'avance",
      "Partage des frais de route",
      "Aide aux bagages",
      "Conducteur sérieux & détendu",
    ],
  },
  {
    id: "graffiti",
    num: "08",
    name: "GRAFFITI",
    title: "Artiste peintre graffeur à la bombe",
    tagline: "Ton idée, ou la mienne — sur un mur.",
    requestType: "croquis",
    ctaLabel: "Demander un croquis",
    color: "#EC4899",
    glow: "rgba(236,72,153,0.32)",
    image:
      "https://images.unsplash.com/photo-1659609281232-d7cd40718180?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Artiste peignant un graffiti à la bombe sur un mur",
    description:
      "Production d'une idée ? Ou me demander la mienne ? Graff de chambres d'enfants, de salles intérieures, de murs extérieurs — et du custom sur vêtements, t-shirts, chaussures et casquettes. Partager l'art, sous toutes ses formes.",
    tasks: [
      "Chambres & pièces intérieures",
      "Murs extérieurs & façades",
      "Custom : t-shirts, baskets, casquettes",
      "Toiles & petites surfaces",
      "Idée fournie ou créée avec toi",
    ],
    ai: true,
  },
  {
    id: "ia-digital",
    num: "09",
    name: "GiulIATeck",
    title: "L'IA qui fait grandir ton entreprise",
    tagline: "Plus de visibilité, plus de clients, plus d'avenir.",
    requestType: "devis",
    ctaLabel: "Demander un devis",
    color: "#6366F1",
    glow: "rgba(99,102,241,0.30)",
    image:
      "https://images.unsplash.com/photo-1744640326166-433469d102f2?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Puce d'intelligence artificielle lumineuse sur une carte électronique",
    description:
      "GiulIATeck, c'est l'IA au service des entreprises : on optimise ta visibilité et ton fonctionnement, on te trouve de nouveaux clients et on te fait évoluer avec les dernières technologies. Conseil, sites web, applications et outils d'intelligence artificielle sur mesure — du diagnostic à la mise en route.",
    tasks: [
      "Optimisation de la visibilité & de l'image",
      "Acquisition de nouveaux clients",
      "Sites web & applications sur mesure",
      "Outils IA & automatisation",
      "Conseil & évolution vers les nouvelles techs",
    ],
  },
];

export const REQUEST_TYPE_LABELS = {
  devis: "Demander un devis",
  croquis: "Demander un croquis",
  accompagnement: "Demander un accompagnement",
  covoiturage: "Demander un trajet",
};
